import { defineAction } from '~/prix'
import { z } from 'zod'
import bullFetchAction from './bullFetch.action.json' with { type: 'json' }
import { bullObject } from '../bullObject'

const bullFetchDefinition = defineAction({
  ...bullFetchAction,

  input: z.object({ id: bullObject.shape.id, includeDeleted: z.boolean().nullish() }),
  output: bullObject,
})

export default bullFetchDefinition
